"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableRowOverrides = void 0;
var createMuiTableRowOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            "&$selected, &$selected:hover": {
                backgroundColor: palette.action.hover,
            },
        },
    });
};
exports.createMuiTableRowOverrides = createMuiTableRowOverrides;
//# sourceMappingURL=MuiTableRow.js.map